export default {
  props: {
    otpRef: { type: String, default: 'otpInput' },
    otpModelKey: { type: String, default: 'code' },
  },

  data() {
    return {
      otpActiveIndex: -1,
    }
  },
  methods: {
    otpInputs() {
      const cmp = this.$refs[this.otpRef]
      return cmp ? cmp.$el.querySelectorAll('input') : []
    },
    otpRememberIndex(e) {
      this.otpActiveIndex = [...this.otpInputs()].indexOf(e.target)
    },
    otpHandleKeydown(e) {
      if (e.key !== 'Backspace') return
      const model = this[this.otpModelKey] || ''

      if (e.repeat) {
        this[this.otpModelKey] = ''
        this.otpActiveIndex = 0
        this.$nextTick(() => this.otpInputs()[0]?.focus())
        return
      }

      if (this.otpActiveIndex < 0) return

      const chars = model.split('')
      chars[this.otpActiveIndex] = ' '
      this[this.otpModelKey] = chars.join('')

      this.$nextTick(() => this.otpInputs()[this.otpActiveIndex]?.focus())
      e.preventDefault()
    },

    otpPlain() {
      return (this[this.otpModelKey] || '').replace(/\s+/g, '')
    },
  },
}
